import React, { useEffect } from "react";
import Header from "../Components/Header";
import QuoteRequestModal from "../Modals/QuoteModal";
import Footer from "../Components/Footer";
import { useNavigate } from "react-router-dom";
import ApiClient from "../../methods/api/apiClient";
import methodModel from "../../methods/methods";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ContactForm } from "../ContactUs/ContactUs";
import { FaAngleDown } from "react-icons/fa";
import { IoIosArrowDown } from "react-icons/io";
import { useAIModal } from "../../hooks/useAIModal";
import AIProductModal from "../Components/AiProductModal/AIProductModal";
import { useSelector } from "react-redux";

// ─── Data ────────────────────────────────────────────────────────────────────

const CATEGORIES = [
  { name: "Soda Dispensers", img: "/assets/card1.png" },
  { name: "Pumps & Parts", img: "/assets/card2.png" },
  { name: "Juice Machines", img: "/assets/card3.png" },
];

// ─── SVG Icons ────────────────────────────────────────────────────────────────

const SodaDispenserIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="60"
    viewBox="0 0 72 72"
    fill="none"
  >
    <path
      d="M65.9941 17.1494H6.00588C4.94216 17.1494 4.07544 18.0148 4.07544 19.0799V23.0983C4.07544 24.1633 4.94216 25.0287 6.00588 25.0287H65.9941C67.0578 25.0287 67.9245 24.1633 67.9245 23.0983V19.0799C67.9245 18.0148 67.0578 17.1494 65.9941 17.1494Z"
      fill="url(#sd_a)"
    />
    <path
      d="M65.5721 9.78786C65.5721 8.72824 64.7162 7.88599 63.6715 7.88599H8.32526C7.2792 7.88599 6.42334 8.72824 6.42334 9.78786V15.7924H65.5721V9.78786Z"
      fill="url(#sd_b)"
    />
    <path
      d="M6.42358 62.2121C6.42358 63.2581 7.27944 64.1139 8.32542 64.1139H63.6703C64.7164 64.1139 65.5722 63.2581 65.5722 62.2121V26.3887H6.42358V62.2121ZM39.0138 32.7872C39.0138 32.4068 39.3276 32.1079 39.693 32.1079H56.3345C56.7148 32.1079 57.0138 32.4068 57.0138 32.7872V61.397H39.0138V32.7872ZM13.4348 40.9232C13.4348 40.377 13.8762 39.9355 14.4156 39.9355H19.8917V34.4676C19.8917 33.9201 20.3318 33.48 20.8779 33.48H24.4711C25.0186 33.48 25.4601 33.9201 25.4601 34.4676V39.9355H30.928C31.4742 39.9355 31.9156 40.377 31.9156 40.9232V44.5164C31.9156 45.0625 31.4742 45.504 30.928 45.504H25.4601V50.9801C25.4601 51.5194 25.0186 51.9595 24.4711 51.9595H20.8779C20.3318 51.9595 19.8917 51.5194 19.8917 50.9801V45.504H14.4156C13.8762 45.504 13.4348 45.0625 13.4348 44.5164V40.9232Z"
      fill="url(#sd_c)"
    />
    <defs>
      <linearGradient
        id="sd_a"
        x1="36"
        y1="17.1494"
        x2="36"
        y2="25.0287"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1B57B6" />
        <stop offset="1" stopColor="#11499C" />
      </linearGradient>
      <linearGradient
        id="sd_b"
        x1="35.9977"
        y1="7.88599"
        x2="35.9977"
        y2="15.7924"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1B57B6" />
        <stop offset="1" stopColor="#11499C" />
      </linearGradient>
      <linearGradient
        id="sd_c"
        x1="35.9979"
        y1="26.3887"
        x2="35.9979"
        y2="64.1139"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1B57B6" />
        <stop offset="1" stopColor="#11499C" />
      </linearGradient>
    </defs>
  </svg>
);

const PumpsPartsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="60"
    viewBox="0 0 72 72"
    fill="none"
  >
    <path
      d="M42 16.2H49.2C50.8568 16.2 52.2 14.8568 52.2 13.2V9C52.2 7.34316 50.8568 6 49.2 6H33C31.3432 6 30 7.34316 30 9V18.6H42V16.2Z"
      fill="url(#pp_a)"
    />
    <path
      d="M24 61.2V57H37.2V61.2H41.4V57H55.2V61.2H57C58.3254 61.2 59.4 62.2746 59.4 63.6C59.4 64.9254 58.3254 66 57 66H21.6C20.2745 66 19.2 64.9254 19.2 63.6C19.2 62.2746 20.2745 61.2 21.6 61.2H24Z"
      fill="url(#pp_b)"
    />
    <path
      d="M8.4 25.8C9.72546 25.8 10.8 26.8745 10.8 28.2V35.4H15V30C15 25.8605 17.7946 22.3738 21.6 21.3235V54.2764C17.7946 53.2261 15 49.7394 15 45.6V40.2H10.8V47.4C10.8 48.7254 9.72546 49.8 8.4 49.8C7.07454 49.8 6 48.7254 6 47.4V28.2C6 26.8745 7.07454 25.8 8.4 25.8Z"
      fill="url(#pp_c)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24 54.6V21H55.2V54.6C44.8 54.6 34.4 54.6 24 54.6ZM29.4 29.4C28.7372 29.4 28.2 29.9372 28.2 30.6C28.2 31.2628 28.7372 31.8 29.4 31.8H38.4C39.0628 31.8 39.6 31.2628 39.6 30.6C39.6 29.9372 39.0628 29.4 38.4 29.4H29.4ZM29.4 36.6C28.7372 36.6 28.2 37.1372 28.2 37.8C28.2 38.4628 28.7372 39 29.4 39H38.4C39.0628 39 39.6 38.4628 39.6 37.8C39.6 37.1372 39.0628 36.6 38.4 36.6H29.4ZM28.2 45C28.2 44.3372 28.7372 43.8 29.4 43.8H38.4C39.0628 43.8 39.6 44.3372 39.6 45C39.6 45.6628 39.0628 46.2 38.4 46.2H29.4C28.7372 46.2 28.2 45.6628 28.2 45Z"
      fill="url(#pp_d)"
    />
    <path
      d="M57.6001 54.0506C62.4685 52.5215 66.0001 47.9731 66.0001 42.6V33C66.0001 27.6268 62.4685 23.0784 57.6001 21.5493V54.0506Z"
      fill="url(#pp_e)"
    />
    <defs>
      <linearGradient
        id="pp_a"
        x1="41.1"
        y1="6"
        x2="41.1"
        y2="18.6"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1B57B6" />
        <stop offset="1" stopColor="#11499C" />
      </linearGradient>
      <linearGradient
        id="pp_b"
        x1="39.3"
        y1="57"
        x2="39.3"
        y2="66"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1B57B6" />
        <stop offset="1" stopColor="#11499C" />
      </linearGradient>
      <linearGradient
        id="pp_c"
        x1="13.8"
        y1="21.3235"
        x2="13.8"
        y2="54.2764"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1B57B6" />
        <stop offset="1" stopColor="#11499C" />
      </linearGradient>
      <linearGradient
        id="pp_d"
        x1="39.6"
        y1="21"
        x2="39.6"
        y2="54.6"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1B57B6" />
        <stop offset="1" stopColor="#11499C" />
      </linearGradient>
      <linearGradient
        id="pp_e"
        x1="61.8001"
        y1="21.5493"
        x2="61.8001"
        y2="54.0506"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1B57B6" />
        <stop offset="1" stopColor="#11499C" />
      </linearGradient>
    </defs>
  </svg>
);

const JuiceMachineIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="60"
    viewBox="0 0 72 72"
    fill="none"
  >
    <path
      d="M66.9503 48.0256C66.5216 47.5335 65.902 47.25 65.2495 47.25H51.7488C51.0961 47.25 50.4764 47.5335 50.048 48.0256C49.6217 48.5179 49.4284 49.1726 49.5206 49.8186L51.7708 65.5686C51.9288 66.676 52.8781 67.5 53.9988 67.5H62.9993C64.12 67.5 65.0693 66.676 65.2274 65.5686L67.4777 49.8186C67.5699 49.1726 67.3764 48.5179 66.9503 48.0256Z"
      fill="url(#jm_a)"
    />
    <path
      d="M56.339 31.5H49.4985V40.5H53.9988V42.75C53.9988 43.9936 55.0052 45 56.249 45H60.7492C61.993 45 62.9994 43.9936 62.9994 42.75V38.16C62.9992 34.4882 60.0108 31.5 56.339 31.5Z"
      fill="url(#jm_b)"
    />
    <path
      d="M15.7466 67.5H44.9982C46.242 67.5 47.2484 66.4936 47.2484 65.25V29.25H15.7466V67.5ZM33.7477 47.25C36.2292 47.25 38.2479 49.2685 38.2479 51.75C38.2479 54.2313 36.2292 56.25 33.7477 56.25C31.2662 56.25 29.2475 54.2313 29.2475 51.75C29.2475 49.2685 31.2662 47.25 33.7477 47.25Z"
      fill="url(#jm_c)"
    />
    <path
      d="M4.52032 29.25C4.52032 29.2982 4.49714 29.3425 4.50029 29.3906L6.75052 65.3906C6.82522 66.577 7.80734 67.5 8.99624 67.5H13.4965V29.25H4.52032Z"
      fill="url(#jm_d)"
    />
    <path
      d="M17.9968 27V18H15.7466C10.3137 18 5.76896 21.8716 4.72339 27H17.9968Z"
      fill="url(#jm_e)"
    />
    <path
      d="M47.0017 27.0001C46.1021 22.6027 42.6468 19.1242 38.2478 18.2275V27.0001H47.0017Z"
      fill="url(#jm_f)"
    />
    <path d="M20.2478 13.5H35.9978V27H20.2478V13.5Z" fill="url(#jm_g)" />
    <path
      d="M22.4968 9V11.25H33.7475V9C34.9913 9 35.9977 7.99357 35.9977 6.75C35.9977 5.50643 34.9913 4.5 33.7475 4.5H22.4968C21.253 4.5 20.2468 5.50643 20.2468 6.75C20.2468 7.99357 21.253 9 22.4968 9Z"
      fill="url(#jm_h)"
    />
    <defs>
      <linearGradient
        id="jm_a"
        x1="58.4991"
        y1="47.25"
        x2="58.4991"
        y2="67.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1B57B6" />
        <stop offset="1" stopColor="#11499C" />
      </linearGradient>
      <linearGradient
        id="jm_b"
        x1="56.249"
        y1="31.5"
        x2="56.249"
        y2="45"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1B57B6" />
        <stop offset="1" stopColor="#11499C" />
      </linearGradient>
      <linearGradient
        id="jm_c"
        x1="31.4975"
        y1="29.25"
        x2="31.4975"
        y2="67.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1B57B6" />
        <stop offset="1" stopColor="#11499C" />
      </linearGradient>
      <linearGradient
        id="jm_d"
        x1="8.99824"
        y1="29.25"
        x2="8.99824"
        y2="67.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1B57B6" />
        <stop offset="1" stopColor="#11499C" />
      </linearGradient>
      <linearGradient
        id="jm_e"
        x1="11.3601"
        y1="18"
        x2="11.3601"
        y2="27"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1B57B6" />
        <stop offset="1" stopColor="#11499C" />
      </linearGradient>
      <linearGradient
        id="jm_f"
        x1="42.6247"
        y1="18.2275"
        x2="42.6247"
        y2="27.0001"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1B57B6" />
        <stop offset="1" stopColor="#11499C" />
      </linearGradient>
      <linearGradient
        id="jm_g"
        x1="28.1228"
        y1="13.5"
        x2="28.1228"
        y2="27"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1B57B6" />
        <stop offset="1" stopColor="#11499C" />
      </linearGradient>
      <linearGradient
        id="jm_h"
        x1="28.1223"
        y1="4.5"
        x2="28.1223"
        y2="11.25"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1B57B6" />
        <stop offset="1" stopColor="#11499C" />
      </linearGradient>
    </defs>
  </svg>
);

const TrustedBrandsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="72"
    height="72"
    viewBox="0 0 72 72"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.8259 46.8002C13.843 42.3538 12.1169 37.0305 12.1169 31.3851V12.5384C12.1169 12.256 12.2852 12.0008 12.5447 11.8895L35.7219 1.95478C35.8995 1.87868 36.1006 1.87868 36.2782 1.95478L59.4554 11.8895C59.7149 12.0008 59.8832 12.256 59.8832 12.5384V31.3851C59.8832 37.7938 57.6588 43.7873 53.8966 48.5544L53.6648 46.6152C53.6645 46.6128 53.6642 46.6106 53.6639 46.6082C53.624 46.2825 53.6776 45.9948 53.8219 45.7031C53.8239 45.6991 55.1307 43.1148 55.1307 43.1148C56.3141 40.7844 55.9151 38.0683 54.1477 36.1857C54.4904 34.6323 54.6705 33.0252 54.6705 31.3851V16.2543C54.6705 15.8024 54.4011 15.3939 53.9857 15.216L36.4446 7.70532C36.1607 7.58376 35.8393 7.58376 35.5553 7.70546L18.0204 15.216C17.605 15.3941 17.3357 15.8024 17.3357 16.2543V31.3851C17.3357 32.6057 17.4355 33.808 17.6276 34.9834L16.6522 35.8984C14.6434 37.7841 14.1369 40.663 15.3838 43.1183C15.3856 43.1218 16.6888 45.6992 16.6888 45.6992C16.8346 45.9922 16.889 46.2811 16.8488 46.6082C16.8485 46.6106 16.8482 46.6128 16.8479 46.6152L16.8259 46.8002ZM19.5952 31.5596C19.5948 31.5015 19.5945 31.4433 19.5945 31.3851V16.9991L36.0002 9.97219L52.4117 16.9992V31.3851C52.4117 32.3839 52.3374 33.3692 52.1938 34.3351L51.7449 33.9139C51.7435 33.9126 51.7421 33.9113 51.7407 33.9101C51.5022 33.6874 51.3574 33.4347 51.2838 33.1188C51.2834 33.1171 51.2831 33.1155 51.2827 33.114L50.6182 30.2859C49.9957 27.612 47.7571 25.7326 45.0092 25.5785H45.0075L42.1116 25.4184H42.1107C41.7819 25.4004 41.5073 25.3001 41.2448 25.1038L38.9225 23.3632C38.921 23.3621 38.9196 23.3611 38.918 23.36C36.7126 21.7154 33.8001 21.7154 31.5946 23.36C31.5932 23.3611 31.5917 23.3621 31.5903 23.3632L29.2666 25.1048C29.2649 25.106 29.2632 25.1073 29.2616 25.1086C29.0032 25.3034 28.728 25.4005 28.4019 25.4184H28.4011L25.5051 25.5785H25.5034C22.7556 25.7326 20.5169 27.612 19.8935 30.2906C19.8929 30.2927 19.7489 30.9056 19.5952 31.5596ZM47.3365 57.1778L51.3442 65.7894C51.4025 65.9107 51.388 66.0417 51.3056 66.1436C51.2279 66.2504 51.1066 66.2988 50.9756 66.2745L45.7755 65.3674L43.1172 69.9321C43.0541 70.0436 42.9377 70.1067 42.8067 70.1019C42.6757 70.097 42.569 70.0243 42.5108 69.903L39.1435 62.6707C41.5738 63.1347 43.9969 62.1232 45.3818 60.0034L46.9655 57.5817C47.072 57.4199 47.1931 57.2864 47.3365 57.1778ZM31.3692 62.6707L28.0018 69.903C27.9485 70.0243 27.8369 70.097 27.7059 70.1019C27.5749 70.1067 27.4586 70.0436 27.3955 69.9321L24.7421 65.3674L19.537 66.2745C19.406 66.2988 19.2848 66.2504 19.2072 66.1436C19.1248 66.0417 19.1103 65.9107 19.1684 65.7894L23.1761 57.1778C23.3189 57.2858 23.4394 57.4183 23.5455 57.579C23.5472 57.5817 25.1316 60.0043 25.1316 60.0043C26.516 62.1232 28.9388 63.1347 31.3692 62.6707ZM37.5678 25.1708L39.8914 26.9122C40.5269 27.3876 41.1914 27.6301 41.9869 27.6739L44.8829 27.8338C46.6147 27.931 48.0263 29.1146 48.4192 30.8026L49.0837 33.6307C49.2633 34.4019 49.6174 35.018 50.1994 35.5614L52.3145 37.5454C53.5806 38.7338 53.9007 40.548 53.1149 42.0955L51.8052 44.6858C51.451 45.3941 51.3249 46.0926 51.4219 46.8833L51.7664 49.7648C51.9701 51.4868 51.0533 53.0827 49.4525 53.7667L46.7893 54.9067C46.0569 55.2171 45.5135 55.6779 45.077 56.3426L43.4907 58.768C42.5399 60.2232 40.813 60.8489 39.1491 60.3493L36.3697 59.5102C35.6129 59.2774 34.8999 59.2774 34.143 59.5102L31.3635 60.3493C29.6996 60.8489 27.9728 60.2232 27.0219 58.768L25.4357 56.3426C24.9992 55.6779 24.4559 55.2171 23.7233 54.9067L21.0602 53.7667C19.4643 53.0827 18.5426 51.4868 18.7463 49.7648L19.0908 46.8833C19.1878 46.0926 19.0617 45.3941 18.7076 44.6858L17.3978 42.0955C16.612 40.548 16.9322 38.7338 18.1983 37.5454L20.3132 35.5614C20.8953 35.018 21.2494 34.4019 21.4289 33.6307L22.0935 30.8026C22.4864 29.1146 23.898 27.931 25.6298 27.8338L28.5257 27.6739C29.3213 27.6301 29.9907 27.3876 30.6214 26.9122L32.9448 25.1708C34.3371 24.1326 36.1755 24.1326 37.5678 25.1708ZM35.2589 54.2261C41.7362 54.2261 47.0254 48.9375 47.0254 42.4545C47.0254 35.9715 41.7362 30.6829 35.2589 30.6829C28.7761 30.6829 23.4873 35.9717 23.4873 42.4545C23.4873 48.9373 28.7761 54.2261 35.2589 54.2261ZM35.2589 51.9672C30.0201 51.9672 25.7461 47.6933 25.7461 42.4545C25.7461 37.2156 30.0201 32.9417 35.2589 32.9417C40.493 32.9417 44.7665 37.2157 44.7665 42.4545C44.7665 47.6931 40.493 51.9672 35.2589 51.9672ZM30.6553 43.3332L33.1368 45.8148C33.5779 46.2558 34.2929 46.2558 34.7341 45.8148L39.8574 40.6913C40.2982 40.2506 40.2982 39.535 39.8574 39.0942C39.4167 38.6535 38.7009 38.6535 38.2601 39.0942L33.9355 43.4189L32.2525 41.7359C31.8118 41.2952 31.096 41.2952 30.6553 41.7359C30.2145 42.1768 30.2145 42.8924 30.6553 43.3332Z"
      fill="url(#tb_a)"
    />
    <defs>
      <linearGradient
        id="tb_a"
        x1="36"
        y1="1.89771"
        x2="36"
        y2="70.1022"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1B57B6" />
        <stop offset="1" stopColor="#11499C" />
      </linearGradient>
    </defs>
  </svg>
);

const ICON_GRID_ITEMS = [
  { label: "Soda Dispensers", icon: <SodaDispenserIcon /> },
  { label: "Pumps & Parts", icon: <PumpsPartsIcon /> },
  { label: "Juice Machines", icon: <JuiceMachineIcon /> },
  { label: "Trusted Commercial Brands", icon: <TrustedBrandsIcon /> },
];

// ─── Sub-components ───────────────────────────────────────────────────────────

const CategoryCard = ({ name, img }) => (
  <div className="bg-white rounded-2xl shadow-sm transition text-center cursor-pointer hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border-transparent hover:border-[#D6E9F8]">
    <img
      src={name.image}
      className="h-[235px] w-full mx-auto object-cover rounded-t-2xl"
      alt={name}
    />
    <div className="px-5 py-4">
      <h3 className="font-semibold text-lg capitalize">{name}</h3>
      <p className="text-sm text-gray-400 capitalize">{name}</p>
    </div>
  </div>
);

export const ProductCard = ({
  NavigateHandler,
  productData,
  productName,
  description,
  price,
  image,
  soldOut,
}) => (
  <div className="bg-white rounded-3xl shadow-md hover:-translate-y-1 transition-all duration-300">
    <div className="relative overflow-hidden rounded-t-3xl">
      {image ? (
        <div
          className="rounded-t-3xl bg-cover bg-no-repeat bg-bottom"
          style={{ backgroundImage: "url('/assets/bg-rectangle.png')" }}
        >
          <img
            src={methodModel.userImg(image)}
            className="h-[180px] md:h-[190px] xl:h-[240px] 2xl:h-[290px] mx-auto object-contain w-full rounded-t-3xl p-3"
            alt={productName}
          />
        </div>
      ) : (
        <div className="h-[180px] 2xl:h-[210px] flex flex-col items-center justify-center bg-[#F5F8FC] rounded-t-2xl gap-2">
          <svg
            width="48"
            height="48"
            fill="none"
            viewBox="0 0 64 64"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="8"
              y="20"
              width="48"
              height="36"
              rx="5"
              fill="#EBF3FB"
              stroke="#C8DCF0"
              strokeWidth="2"
            />
            <path
              d="M20 20V16a12 12 0 0124 0v4"
              stroke="#C8DCF0"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <circle
              cx="32"
              cy="36"
              r="6"
              fill="#D6E9F8"
              stroke="#116DAE"
              strokeWidth="1.5"
            />
            <line
              x1="32"
              y1="33"
              x2="32"
              y2="36"
              stroke="#116DAE"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
            <circle cx="32" cy="39.5" r="0.8" fill="#116DAE" />
          </svg>
          <span className="text-[11px] text-gray-400 font-medium">
            No Image
          </span>
        </div>
      )}
      {soldOut && (
        <span className="absolute bottom-2 right-2 bg-gray-800 text-white text-xs px-3 py-1 rounded-full">
          Sold Out
        </span>
      )}
    </div>
    <div className="p-4 pb-7">
      <div className="space-y-1">
        <h3 className="text-[#100000] font-[500] text-[15px] line-clamp-1 capitalize">
          {productName}
        </h3>
        <p className="text-sm text-[#A1A1A1] text-[15px] line-clamp-1 capitalize">
          {description || "No description available"}
        </p>
        {/* <p className="text-sm">XCD {price ? Number(price).toLocaleString("en", { minimumFractionDigits: 2 }) : "0.00"}</p> */}
      </div>
      {/* <button type="button" onClick={()=>NavigateHandler(productData?.id||productData?._id)} className="w-full bg-gradient-to-br from-[#115B9D] to-[#116DAE] text-white rounded-full text-sm hover:scale-[1.04] duration-300 transition py-2 px-5 mt-5">
        View Details
      </button> */}
    </div>
  </div>
);

// Skeleton for product cards while loading
export const ProductSkeleton = () => (
  <div className="bg-white rounded-2xl shadow-sm animate-pulse">
    <div className="h-[180px] bg-gray-100 rounded-t-2xl" />
    <div className="p-4 space-y-3">
      <div className="h-4 bg-gray-100 rounded-full w-3/4" />
      <div className="h-3 bg-gray-100 rounded-full w-full" />
      <div className="h-3 bg-gray-100 rounded-full w-1/3" />
      <div className="h-8 bg-gray-100 rounded-full mt-4" />
    </div>
  </div>
);

const IconCard = ({ label, icon }) => (
  <div
    className="rounded-2xl p-6 shadow-sm space-y-2 bg-cover bg-no-repeat"
    style={{ backgroundImage: "url('./assets/card-bg.png')" }}
  >
    <div className="flex justify-center">{icon}</div>
    <p className="font-medium text-gray-700">{label}</p>
  </div>
);

// ─── Page ─────────────────────────────────────────────────────────────────────

export default function Hometwo() {
  const user = useSelector((state) => state.user);
  const [isOpen1, setIsOpen] = React.useState(false);
  const [featuredProducts, setFeaturedProducts] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(true);
  const [Equpment, setEqupmentListing] = React.useState([]);
  const { isOpen, openModal, closeModal } = useAIModal();
  const [detail, setDetail] = React.useState(null);

  const navigate = useNavigate();

  const GetUserDetail = () => {
    if (!user?._id) return;
    ApiClient.get(`user/profile?id=${user?._id || user?.id}`).then((res) => {
      if (res?.success) {
        setDetail(res?.user_data);
      }
    });
  };

  React.useEffect(() => {
    GetUserDetail();
    setIsLoading(true);
    ApiClient.get("product/browse", { page: 1, count: 4, isAiGenerated: "0" })
      .then((res) => {
        setFeaturedProducts(res.data?.products || []);
        // ?.filter((_product)=>_product?.isFeatured)
        setIsLoading(false);
      })
      .catch(() => {
        setFeaturedProducts([]);
        setIsLoading(false);
      });
  }, []);

  const NavigateHandler = (id) => {
    navigate(`/products/detail?id=${id}`);
  };

  useEffect(() => {
    fetchEquipment();
  }, []);

  const fetchEquipment = async () => {
    try {
      const params = { page: 1, count: 100000, status: "active" };
      const query = new URLSearchParams(params).toString();
      const res = await ApiClient.get(`equipment-type/listing?${query}`);
      if (res?.success) {
        let data = res?.data?.data;
        if (data.length) {
          data = data.map((res) => ({
            name: res.title,
            id: res.id,
            image: res.image,
          }));
          data.sort((a, b) => a.name.localeCompare(b.name));
        }
        console.log(data, "datadatadatadata222");

        setEqupmentListing(data || []);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 3 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 1 },
      },
    ],
  };
  const [isDragging, setIsDragging] = React.useState(false);

  const handleMouseDown = () => setIsDragging(false);
  const handleMouseMove = () => setIsDragging(true);

  return (
    <div className="bg-[#0A2540]">
      <Header />
      <div className="min-h-[calc(100vh_-_0px)] md:min-h-[calc(100vh_-_0px)] lg:pb-20">
        {/* HERO */}
        <div
          className="bg-cover bg-no-repeat bg-bottom"
          style={{ backgroundImage: "url('./assets/home-banner-2.png')" }}
        >
          <div className="max-md:bg-gradient-to-t from-[#0A2540] to-[#0a254000]">
            <section className="container mx-auto grid grid-cols-1 items-center gap-10 min-h-[500px] sm:min-h-[620px] lg:min-h-[700px] 2xl:min-h-[850px] pt-[120px] pb-[80px] px-5">
              <div className="max-sm:max-w-[440px] max-w-[520px] xl:max-w-[650px] 2xl:max-w-[782px]">
                <h1 className="text-[32px] sm:text-[45px] xl:text-[56px] 2xl:text-[67px] font-[500] text-white leading-tight">
                  Sourcing the Caribbean.
                  <span className="text-[#98C65A]"> Anything you need. </span>
                </h1>

                <p className="text-white text-md sm:text-[19px] xl:text-[25px] 2xl:text-[32px] leading-relaxed mt-5 sm:mt-8">
                  Procurement and delivery for hospitality, marine, food
                  service, retail, and industrial operators across the region.
                </p>

                <div className="flex flex-wrap gap-5 mt-8 sm:mt-12">
                  <button
                    type="button"
                    // onClick={() => navigate("/products")}
                    onClick={() => openModal()}
                    className="text-md sm:text-xl bg-[#98C65A] text-[#0A2540] rounded-md shadow hover:scale-[1.04] duration-300 transition px-10 py-3 sm:py-4"
                  >
                    Request a Quote
                  </button>
                  {/* <button
                  className="border border-[#fff] text-md sm:text-xl max-[480px]:w-full text-white rounded-md shadow hover:scale-[1.04] duration-300 transition px-10 py-4"
                  onClick={() => setIsOpen(true)}
                >
                  Request a Quote
                </button> */}
                </div>
              </div>
            </section>
          </div>
        </div>

        {/* CATEGORIES */}
        {/* <section className="container mx-auto px-5 py-10">
          <h2 className="text-white text-[22px] md:text-[28px] font-semibold mb-6">Explore Category</h2>
          <div className="slider_main relative">
            <div className="bg_slider absolute right-0 top-0 z-[2] h-full md:w-[200px] xl:w-[280px] bg-gradient-to-r from-[#0a254000] via-[#0a2540d9] to-[#0a2540]"></div>
          <Slider {...settings}>
            {Equpment.map((cat, index) => (
              <div key={index} className="">
                <div className="bg-[#0A2540] rounded-2xl shadow-md transition text-center cursor-pointer hover:shadow-[0px_0px_10px_0px_#ACCF60] border border-[#0A2540] hover:border-[#ACCF60] transition duration-300 ">
                  <div className="rounded-2xl bg-cover bg-no-repeat" style={{ backgroundImage: "url('/assets/box-bg.png')" }}>
                    <img
                      src={methodModel.userImg(cat.image)}
                      className="h-[220px] 2xl:h-[250px] w-full object-contain rounded-t-2xl p-3"
                      alt={cat.name}
                      //  onClick={()=>navigate(`/products?equipment=${cat?.id}`)}
                      onMouseDown={handleMouseDown}
                      onMouseMove={handleMouseMove}
                      onClick={() => {
                        if (!isDragging) {
                          navigate(`/products?equipment=${cat?.id}`);
                        }
                      }}
                    />
                    <div className="px-5 py-4">
                      <h3 className="text-white font-semibold text-lg xl:text-xl">{cat.name}</h3>
                    </div>
                  </div>

                </div>
              </div>
            ))}
          </Slider>
          </div>
        </section> */}

        {/* <div className="relative">
          <img
            src="/assets/light-bg.png"
            className="absolute right-0 top-[-160px] w-[300px] h-[420px] max-w-full object-contain"
          />
        </div> */}

        {/* FEATURED PRODUCTS */}
        {/* <section className="relative z-[9] container mx-auto px-5 py-10">
          <h2 className="text-white text-[22px] md:text-[28px] font-semibold mb-6">Featured Products</h2>
          <div className="grid max-[480px]:grid-cols-1 grid-cols-2 md:grid-cols-3 gap-5 lg:gap-7">
            {isLoading
              ? Array.from({ length: 4 }).map((_, i) => <ProductSkeleton key={i} />)
              : featuredProducts.length > 0
                ? featuredProducts.slice(0, 8).map((p, i) => <ProductCard key={p._id || i} productData={p} NavigateHandler={NavigateHandler} {...p} />)
                : (
                  <div className="col-span-full flex flex-col items-center justify-center py-16 text-center">
                    <svg width="64" height="64" fill="none" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" className="mb-4">
                      <rect x="8" y="20" width="48" height="36" rx="5" fill="#EBF3FB" stroke="#C8DCF0" strokeWidth="2" />
                      <path d="M20 20V16a12 12 0 0124 0v4" stroke="#C8DCF0" strokeWidth="2" strokeLinecap="round" />
                      <circle cx="32" cy="36" r="6" fill="#D6E9F8" stroke="#116DAE" strokeWidth="1.5" />
                      <line x1="32" y1="33" x2="32" y2="36" stroke="#116DAE" strokeWidth="1.5" strokeLinecap="round" />
                      <circle cx="32" cy="39.5" r="0.8" fill="#116DAE" />
                    </svg>
                    <p className="text-gray-500 font-medium">No products available</p>
                    <p className="text-sm text-gray-500 mt-1">Check back soon for new arrivals.</p>
                  </div>
                )
            }
          </div>
          <p className="text-white text-md text-center flex items-center gap-1 justify-center cursor-pointer hover:text-[#98C65A] transition-all duration-300 mt-12">See more <IoIosArrowDown className="relative top-[1px]" /></p>
        </section> */}

        {/* <div className="relative">
          <img
            src="/assets/light-left.png"
            className="absolute left-0 bottom-[90px] w-[170px] h-[380px] max-w-full object-contain"
          />
        </div> */}

        <div className="container mx-auto px-5 py-5">
          <div
            className="h-[3px]"
            style={{
              background:
                " linear-gradient(90deg, #0A2540, #98C65A, #0A2540) border-box",
            }}
          ></div>
        </div>

        <div className="relative">
          <img
            src="/assets/rounded-dot.png"
            className="absolute right-0 top-[-160px] w-[300px] h-[420px] max-w-full object-contain"
          />
        </div>

        <section className="container mx-auto px-5 py-10">
          <div className="mb-12">
            <h2 className="text-center text-white text-[22px] md:text-[28px] font-semibold">
              Contact US
            </h2>
            <p className="text-center text-sm text-[#A1A1A1]">
              Fill out the form below and our team will get back to you shortly.
            </p>
          </div>
          <div className="relative z-[9] bg-[#30475E] rounded-2xl shadow-md py-8 px-5 md:px-8">
            <div className="max-lg:flex-wrap flex gap-5">
              <div className="z-[9] w-full">
                <div className="w-full grid grid-cols-12 gap-5">
                  <div className="col-span-12 sm:col-span-6 space-y-1">
                    <label className="text-sm text-white">Full Name</label>
                    <input
                      type="text"
                      className="text-sm text-white bg-transparent rounded-2xl w-full border-[1px] border-[#7D8C9A] px-5 py-3"
                      placeholder="Enter full name"
                    />
                  </div>
                  <div className="col-span-12 sm:col-span-6 space-y-1">
                    <label className="text-sm text-white">
                      Email Address Name
                    </label>
                    <input
                      type="text"
                      className="text-sm text-white bg-transparent rounded-2xl w-full border-[1px] border-[#7D8C9A] px-5 py-3"
                      placeholder="Enter email address"
                    />
                  </div>
                  <div className="col-span-12 space-y-1">
                    <label className="text-sm text-white">Message</label>
                    <textarea
                      type="text"
                      rows="3"
                      className="text-sm text-white bg-transparent rounded-2xl w-full border-[1px] border-[#7D8C9A] px-5 py-3"
                      placeholder="Write you message here......"
                    />
                  </div>
                </div>
                <div className="flex justify-end mt-5">
                  <button className="sm:text-md flex gap-2 items-center bg-[#98C65A] text-[#0A2540] rounded-md hover:scale-[1.04] duration-300 transition px-5 py-2">
                    Submit
                  </button>
                </div>
              </div>
              <div className="max-lg:hidden min-w-[365px] xl:min-w-[385px] w-[365px] xl:w-[385px]">
                <img
                  src="/assets/Contact-img.png"
                  className="h-[390px] xl:h-[410px] object-contain absolute bottom-[0px] right-[0px]"
                />
              </div>
            </div>
          </div>
        </section>

        <div className="relative">
          <img
            src="/assets/light-left.png"
            className="absolute left-0 bottom-[-90px] w-[170px] h-[380px] max-w-full object-contain"
          />
        </div>

        {/* ICON GRID */}
        {/* <section className="container mx-auto px-5 py-10 grid max-[480px]:grid-cols-1 grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 lg:gap-7 text-center">
        {ICON_GRID_ITEMS.map((item) => (
          <IconCard key={item.label} {...item} />
        ))}
      </section> */}
        <QuoteRequestModal
          open={isOpen1}
          setOpen={setIsOpen}
          onSuccess={() => console.log("submitted")}
        />
        <AIProductModal isOpen={isOpen} onClose={closeModal} detail={detail} />
      </div>
      {methodModel.TokenChecker() && <Footer />}
    </div>
  );
}
